import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { dig } from 'spiceutils';
import { getSurveyForCdf, getCountriesForSurvey } from 'utils/AYDAUtils';
import { Select } from 'spicecomponents';

import { getPresetBreakList } from '../../../containers/App/actions';
import { makeSelectPresetList } from '../../../containers/App/selectors';

export class Country extends React.Component {
  onChange(value) {
    this.props.updateCDF('Country', value);

    if (this.props.storePresetLists !== false && dig(this.props.controlList, ['BreakList', 'Visible']) === true) {
      this.props.getPresetBreakLists(value);
    }
  }

  getOptions() {
    return getCountriesForSurvey(getSurveyForCdf(this.props.cdf), this.props.controlList);
  }

  render() {
    if (dig(this.props.controlList, ['Country', 'Visible']) === true && this.getOptions().length > 2) {
      return (
        <div className={this.props.className}>
          <label htmlFor="Country">Select a Country</label>
          <Select
            name="Country"
            placeholder="None"
            options={this.getOptions()}
            value={this.props.cdf.Country || ''}
            onChange={(e) => this.onChange(e)}
          />
        </div>
      );
    }
    return null;
  }
}

Country.propTypes = {
  updateCDF: PropTypes.func,
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  getPresetBreakLists: PropTypes.func,
  className: PropTypes.string,
  storePresetLists: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  presetBreakLists: makeSelectPresetList('BreakList'),
});

export function mapDispatchToProps(dispatch) {
  return {
    getPresetBreakLists(value) {
      dispatch(getPresetBreakList(value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(Country);



// WEBPACK FOOTER //
// ./app/components/FormControls/Country/index.js